module.exports = __webpack_public_path__ + "img/icon_jian.e8caa48d.png";